<!--Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.-->
<div class="loading">
  <p-progressSpinner strokeWidth="3"
                     styleClass="custom-spinner"></p-progressSpinner>
</div>
